export const ADD_CATALOG = 'ADD_CATALOG';
export const ADD_ELEMENT_EDITING_CATALOG = 'ADD_ELEMENT_EDITING_CATALOG';
export const GET_CATALOG_BY_ID = 'GET_CATALOG_BY_ID';
export const GET_CATALOG_FORM_CONFIG = 'GET_CATALOG_FORM_CONFIG';
export const GET_CATALOGS = 'GET_CATALOGS';
export const MODIFY_EDITING_CATALOG = 'MODIFY_EDITING_CATALOG';
export const REMOVE_ELEMENT_EDITING_CATALOG = 'REMOVE_ELEMENT_EDITING_CATALOG';
export const RESET_CATALOG_FORM = 'RESET_CATALOG_FORM';
export const RESET_CATALOGS = 'RESET_CATALOGS';
export const SET_CATALOGS_FILTERS = 'SET_CATALOGS_FILTERS';
export const SET_CATALOGS_PAGINATION = 'SET_CATALOGS_PAGINATION';
export const TOGGLE_CATALOG = 'TOGGLE_CATALOG';
export const UPDATE_CATALOG = 'UPDATE_CATALOG';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/constants/catalogs_constants.js